import { Utility } from './../../../common/utility';
import { Component, OnInit, Inject } from '@angular/core';
import { MdInputModule, MdRadioModule, MdDialog, MdDialogRef, MD_DIALOG_DATA, MdSelectModule } from '@angular/material';
import { NotificationService } from './../../../shared/services/notification.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
@Component({
  templateUrl: 'new-condition-popup.component.html',
  providers: [NotificationService]
})

export class MedicalConditionPopupComponent implements OnInit {
  public newConditionName = '';
  public newConditionForm;
  constructor(public utility: Utility,
    public formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<MedicalConditionPopupComponent>,
    public dialogService: DialogService) {
      this.createForm();
    }

  ngOnInit() {

  }

  createForm() {
    this.newConditionForm = this.formBuilder.group({
      name: ['', [Validators.required]]
    });
  }

  onSubmit() {
    if (this.newConditionForm.valid) {
      this.dialogRef.close(this.newConditionForm.value.name);
    }
  }

  onCloseDialog() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/medical-conditions/new-condition-popup.component.ts